import { useCallback } from 'react';
import { create } from 'zustand';

import { axiosInstanceV3 } from '@mais-retorno-front/configs/axios-config';

interface IUseStore {
  stats: any;
  loading: boolean;
  setLoading: (isLoading: boolean) => void;
  setStats: (stats: any) => void;
}

const useStore = create<IUseStore>((set) => ({
  stats: null,
  loading: true,
  setLoading: (isLoading: boolean) => set({ loading: isLoading }),
  setStats: (stats: any) => set({ stats }),
}));

export const useSheetFundStats = () => {
  const fundStats = useStore((state) => state.stats);
  const loading = useStore((state) => state.loading);
  const setLoading = useStore((state) => state.setLoading);
  const setStats = useStore((state) => state.setStats);

  const getStats = useCallback(
    async ({
      fundSlug,
      start_date = null,
      end_date = null,
    }: {
      fundSlug: string;
      start_date?: number;
      end_date?: number;
    }) => {
      setLoading(true);

      try {
        const { data: stats } = await axiosInstanceV3.get(
          `/funds/stats/${fundSlug}/details`,
          {
            params: { start_date, end_date },
          }
        );

        setStats(stats);
      } catch (error) {
        setStats(null);
      }

      setLoading(false);
    },
    [setStats, setLoading]
  );

  return {
    loadingStats: loading,
    fundStats,
    getStats,
  };
};
